import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@material-ui/core';
import { Loader } from '@saviynt/design-system';
import ObjectTypeCard from './ObjectTypeCard';
import useStyles from './styles/ObjectTypeGrid.styles';

function ObjectTypeGrid({
  automatedMigration,
  assistedMigration,
  objectTypeCounts,
  onObjectTypeClick,
  sourceType,
  activeTab,
  onTabChange,
}) {
  const classes = useStyles();
  const [expandedCards, setExpandedCards] = useState({});

  if (automatedMigration?.length === 0 && assistedMigration?.length === 0) {
    return (
      <div className={classes.loader}>
        <Loader kind="loop" size="large" format="inline" color="brand" />
      </div>
    );
  }

  return (
    <div>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => onTabChange(newValue)}
        TabIndicatorProps={{ className: classes.tabIndicator }}
        className={classes.tabs}>
        <Tab
          label="Automated Migration"
          className={activeTab === 0 ? classes.tabActive : classes.tab}
        />
        <Tab
          label="Assisted Migration"
          className={activeTab === 1 ? classes.tabActive : classes.tab}
        />
      </Tabs>

      {activeTab === 0 && automatedMigration?.length > 0 && (
        <div className={classes.grid}>
          {automatedMigration.map((objType) => (
            <ObjectTypeCard
              key={objType.type}
              objType={objType}
              count={objectTypeCounts[objType.type] || 0}
              onSelect={() => onObjectTypeClick(objType.type)}
              isExpanded={expandedCards[objType.type]}
              onToggleExpand={() =>
                setExpandedCards((prev) => ({ ...prev, [objType.type]: !prev[objType.type] }))
              }
              activeTab={activeTab}
              sourceType={sourceType}
            />
          ))}
        </div>
      )}

      {activeTab === 1 && assistedMigration?.length > 0 && (
        <div className={classes.grid}>
          {assistedMigration.map((objType) => (
            <ObjectTypeCard
              key={objType.type}
              objType={objType}
              count={objectTypeCounts[objType.type] || 0}
              onSelect={() => onObjectTypeClick(objType.type)}
              isExpanded={expandedCards[objType.type]}
              onToggleExpand={() =>
                setExpandedCards((prev) => ({ ...prev, [objType.type]: !prev[objType.type] }))
              }
              activeTab={activeTab}
              sourceType={sourceType}
            />
          ))}
        </div>
      )}
    </div>
  );
}

ObjectTypeGrid.propTypes = {
  automatedMigration: PropTypes.arrayOf(PropTypes.shape({})),
  assistedMigration: PropTypes.arrayOf(PropTypes.shape({})),
  objectTypeCounts: PropTypes.shape({}),
  onObjectTypeClick: PropTypes.func,
  sourceType: PropTypes.string,
  activeTab: PropTypes.number,
  onTabChange: PropTypes.func,
};

ObjectTypeGrid.defaultProps = {
  automatedMigration: [],
  assistedMigration: [],
  objectTypeCounts: {},
  onObjectTypeClick: undefined,
  sourceType: null,
  activeTab: 0,
  onTabChange: undefined,
};

export default ObjectTypeGrid;
